import React, { useState } from 'react';
import { X } from 'lucide-react';

const OUTCOME_OPTIONS = [
  { value: 'strong_fit', label: 'Strong fit', emoji: '🌟' },
  { value: 'good_fit', label: 'Good fit', emoji: '👍' },
  { value: 'not_aligned', label: 'Not aligned', emoji: '↔️' },
  { value: 'underqualified', label: 'Underqualified', emoji: '📊' },
  { value: 'other', label: 'Other', emoji: '💬' },
];

export default function HiringOutcomePicker({ candidateName, onSelect, onCancel }) {
  const [selected, setSelected] = useState(null);
  const [note, setNote] = useState('');

  const handleSubmit = () => {
    if (!selected) return;
    if (selected === 'other' && !note.trim()) return;
    onSelect(selected, selected === 'other' ? note.trim() : null);
  };

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
      <div className="bg-gradient-to-r from-vouch-navy to-vouch-teal p-4">
        <div className="flex items-center justify-between">
          <h3 className="font-bold text-white text-sm">Hiring Outcome</h3>
          <button onClick={onCancel} className="text-white hover:text-cyan-200" aria-label="Cancel">
            <X size={18} />
          </button>
        </div>
        <p className="text-cyan-100 text-xs mt-1">
          How did it go with {candidateName}?
        </p>
      </div>
      <div className="p-4">
        <div className="space-y-1.5">
          {OUTCOME_OPTIONS.map(option => (
            <button
              key={option.value}
              onClick={() => setSelected(option.value)}
              className={`w-full text-left py-2.5 px-3 text-sm rounded-lg border-2 transition-colors flex items-center gap-2 ${
                selected === option.value
                  ? 'border-vouch-teal bg-cyan-50 text-vouch-navy font-semibold'
                  : 'border-gray-200 text-gray-700 hover:border-gray-300 hover:bg-gray-50'
              }`}
            >
              <span>{option.emoji}</span>
              {option.label}
            </button>
          ))}
        </div>

        {selected === 'other' && (
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Provide a note about this outcome..."
            className="w-full mt-3 px-3 py-2 border-2 border-gray-200 rounded-lg text-sm h-20 resize-none focus:border-vouch-teal focus:outline-none"
            autoFocus
          />
        )}

        <div className="flex gap-2 mt-4">
          <button
            onClick={onCancel}
            className="flex-1 py-2.5 bg-gray-100 hover:bg-gray-200 rounded-lg text-sm font-semibold"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={!selected || (selected === 'other' && !note.trim())}
            className="flex-1 py-2.5 bg-gradient-to-r from-vouch-navy to-vouch-teal text-white rounded-lg text-sm font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Submit Feedback
          </button>
        </div>
      </div>
    </div>
  );
}
